import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const API_URL = "https://ims.holdthechild.net";

const ReturnItemsModal = ({ issuedItem, onClose, onSuccess }) => {
    const [quantityReturned, setQuantityReturned] = useState(1);
    const [loading, setLoading] = useState(false);

    const remaining =
        issuedItem.quantityIssued -
        (issuedItem.quantityConsumed || 0) -
        (issuedItem.quantityReturned || 0);
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (quantityReturned <= 0) {
            toast.error("Please enter a valid quantity.");
            return;
        }

        if (quantityReturned > remaining) {
            toast.error("Quantity exceeds remaining stock.");
            return;
        }

        setLoading(true);
        const token = localStorage.getItem("token");

        try {
            await axios.post(
                `${API_URL}/api/issued-items/project/return`,
                { issuedItemId: issuedItem._id, quantityReturned: Number(quantityReturned) },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            toast.success("Items returned successfully!");
            onSuccess(issuedItem._id, quantityReturned);
            onClose();
        } catch (err) {
            toast.error(err.response?.data?.message || "Failed to return items.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <form onSubmit={handleSubmit} className="bg-white rounded-xl p-6 w-96 shadow-lg">
                <h2 className="text-xl font-bold text-orange-600 mb-4">Return Items</h2>
                <p className="mb-2">Item: <b>{issuedItem.itemName}</b></p>
                <p className="mb-2">Remaining Quantity: <b>{remaining}</b></p>

                <input
                    type="number"
                    min="1"
                    max={remaining}
                    value={quantityReturned}
                    onChange={(e) => setQuantityReturned(Number(e.target.value))}
                    className="w-full border rounded-md px-3 py-2 mb-4"
                    placeholder="Quantity to return"
                    required
                />

                <div className="flex justify-end gap-2">
                    <button type="button" onClick={onClose} className="px-4 py-2 border rounded-md">Cancel</button>
                    <button type="submit" disabled={loading} className="px-4 py-2 bg-orange-500 text-white rounded-md">
                        {loading ? "Processing..." : "Submit"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ReturnItemsModal;
